import 'assets/css/home.css';

import { useTranslation } from "react-i18next";

import SlideBanner from "components/banner/SlideBanner";
import Slogan from "./Slogan";
import Info from "./Info";
import About from './About';
import Solution from "./Solution";
import Partners from "./Partners";

import bg1 from 'assets/images/home/visual01.jpg';
import bg2 from 'assets/images/home/visual02.jpg';
import bg3 from 'assets/images/home/visual03.jpg';
import bg4 from 'assets/images/home/visual04.jpg';
import bg5 from 'assets/images/home/visual05.jpg';

export default function Home(){
  const {t} = useTranslation();
  const imgs = [bg5, bg3, bg4, bg1, bg2];
  const pages = [];
  for(let i = 1; i < 6; i++){
    pages.push({
      title:t(`home.banner.title-${i}`),
      comment:t(`home.banner.comment-${i}`),
      image:imgs[i-1]
    })
  }


  return (
    <div className="relative flex flex-col">
      <SlideBanner className="" pages={pages}/>
      <Slogan className="z-20"/>
      <Info/>
      <About/>
      <Solution/>
      <Partners/>
    </div>
  );
}